<template>
  <v-stepper v-model="step" vertical :rounded="rounded" :elevation="elevation">
    <template v-for="(data, index) in data">
      <v-stepper-step
        :editable="freeNavigate"
        :key="'header' + index"
        :color="$config.dados.primary"
        :complete="data.complete || step > index + 1"
        :step="index + 1"
      >
        {{ data.title }}
      </v-stepper-step>
      <v-stepper-content :key="'content' + index" :step="index + 1">
        <v-row no-gutters v-if="data.sideInfo?.title" class="pa-0 ma-0">
          <v-col :cols="!mdAndUp ? 12 : 3" class="pr-5">
            <h4 class="mb-1">
              <v-icon>{{ data.sideInfo?.icon }}</v-icon>
              {{ data.sideInfo?.title }}
            </h4>
            <small class="grey--text d-flex">
              {{ data.sideInfo?.subtitle }}
            </small>
          </v-col>
          <v-col :cols="!mdAndUp ? 12 : 9">
            <slot :name="`content${index + 1}`" />
            <v-btn @click="step = index + 2">{{
              data.textNext ? data.textNext : $t("new-event.buttons.next")
            }}</v-btn>
            <v-btn @click="step = index">{{
              data.textPrev ? data.textPrev : $t("new-event.buttons.back")
            }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <slot :name="`content${index + 1}`" />

            <div class="d-flex justify-end mb-1 mt-4">
              <v-btn
                v-if="data.showPrev"
                outlined
                prepend-icon="mdi-subdirectory-arrow-left"
                rounded
                :disabled="data.disabledPrev"
                :color="$config.dados.primary"
                @click="handlePrev(data.prev, index)"
                class="mr-2"
              >
                <template>
                  <v-icon> mdi-keyboard-return </v-icon>
                  <span v-if="smAndUp" class="ml-1">{{
                    data.textPrev ? data.textPrev : $t("new-event.buttons.back")
                  }}</span>
                </template>
              </v-btn>
              <v-btn
                v-if="data.middleButton"
                :loading="data.loadingMiddleButton"
                @click="data.actionMiddleButton"
                color="#7513BF"
                class="white--text mr-2"
                rounded
              >
                <span v-if="smAndUp" class="mr-1">
                  {{ data.middleButton || $t("new-event.buttons.next") }}
                </span>
                <v-icon>
                  {{ data.iconMiddleButton }}
                </v-icon>
              </v-btn>
              <v-btn
                rounded
                :disabled="data.disabledNext"
                @click="handleNext(data.next, index)"
                :color="$config.dados.primary"
                class="white--text mr-5"
                :loading="data.loadingNext || getLoadingEvent"
              >
                <template>
                  <span v-if="smAndUp" class="mr-1">{{
                    data.textNext ? data.textNext : $t("new-event.buttons.next")
                  }}</span>
                  <v-icon>
                    {{ data.iconNext || "mdi-arrow-right-circle" }}
                  </v-icon>
                </template>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-stepper-content>
    </template>
  </v-stepper>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
import { mapGetters } from "vuex";

export default {
  name: "MultiStepper",
  mixins: [displayHelpers],
  props: {
    freeNavigate: {
      type: Boolean,
      default: false,
    },
    startingStep: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      default: function () {
        return [
          {
            title: "",
            subtitle: "",
            loading: false,
            disabledPrev: false,
            disabledNext: false,
            next: () => {},
            prev: () => {},
            isValid: false,
            textPrev: "",
            showPrev: true,
            textNext: "",
            iconNext: "",
            loadingNext: false,
            middleButton: "",
            iconMiddleButton: "",
            loadingMiddleButton: false,
            actionMiddleButton: () => {},
            sideInfo: {
              title: "",
              subtitle: "",
              icon: "",
            },
          },
        ];
      },
    },
    elevation: {
      type: Number,
      default: 2,
    },
    rounded: {
      type: String,
      default: "md",
    },
  },
  computed: {
    ...mapGetters(["getLoadingEvent"]),
  },
  methods: {
    handleNext(nextFn, index) {
      if (nextFn) {
        const result = nextFn();
        if (result && typeof result.then === "function") {
          result.then(res => {
            if (res) {
              this.step = index + 2;
            }
          });
        } else if (result) {
          this.step = index + 2;
        }
      } else {
        this.step = index + 2;
      }
    },
    handlePrev(prevFn, index) {
      if (prevFn) {
        const result = prevFn();
        if (result && typeof result.then === "function") {
          result.then(res => {
            if (res) {
              this.step = index;
            }
          });
        } else if (result) {
          this.step = index;
        }
      } else {
        this.step = index;
      }
    },
  },
  mounted() {
    this.step = this.startingStep || 1;
  },
  data() {
    return {
      step: 1,
    };
  },
};
</script>

<style scoped></style>
